import React, { useState } from 'react'
import { Form, Input, message } from 'antd'
import AuthLayout from './authLayout'
import BlueButton from '../../components/shared/BlueButton';
import { forgotPassword } from '../../api/auth';
import { useNavigate } from 'react-router-dom';

export default function ForgotPassword() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values) => {
        const { email } = values;
        setLoading(true)
        try {
            const res = await forgotPassword({ email });
            if (res) {
                message.success("Reset link sent to your email");
                form.resetFields()
                navigate("/")
            }
        } catch (error) {
            message.error("Something went wrong, please try again later");
        }
        setLoading(false)
    }

    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
        message.error("Something went wrong, please try again later");
    };

    return (
        <AuthLayout>
            <section>
                <Form form={form} layout='vertical' onFinish={onFinish} onFinishFailed={onFinishFailed}>
                    <Form.Item name="email" label="Email" rules={[{ required: true }]} ><Input type='email' className='rounded-none' /></Form.Item>
                    <p className='text-[#A2A2A2] text-sm mb-6'>Please enter your email address and we will send you a link to reset your password.</p>
                    <Form.Item className='flex justify-center'>
                        <BlueButton type="primary" className="rounded-none min-w-[132.5px]" htmlType="submit" disabled={loading}>{
                            loading ? "Loading..." : "Reset Password"}
                        </BlueButton>
                    </Form.Item>
                </Form>
            </section>
        </AuthLayout>
    )
}
